import Persistable from "../../../storage/persistable";

export default class TennisGameContextSnapshot extends Persistable {}
